import { COLORS } from 'helpers/globals'

export default {
  container: {
    background: 'white',
    flex: '1 0 108px',
    borderBottom: `1px solid ${COLORS.quaternary}`,
    padding: '.8rem',
    zIndex: 5,
    userSelect: 'none',
    border: 0,
    width: '100%',
    borderRight: 0
  },
  exportContent: {
    height: '100%',
    position: 'relative',
    maxWidth: '100% !important',
    margin: '0 !important',
    padding: '0 !important'
  },
  cameraInfo: {
    fontSize: '2rem',
    flex: '1 1 auto',
    '& span': {
      paddingRight: '3.5rem'
    }
  },
  exportTopRow: {
    height: '100%',
    display: 'flex',
    position: 'absolute',
    width: '100vw',
    alignItems: 'center',
    gap: '1rem',
    paddingRight: '2.1rem'
  },
  modelImage: {
    height: '100%',
    maxWidth: '100%'
  },
  wiringInfo: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '2rem',
    paddingLeft: '1.5rem',
    borderLeft: `1px solid ${COLORS.quaternary}`
  },
  networkClosetIcon: {
    fontSize: '2.5rem',
    verticalAlign: '-.25em',
    marginRight: '.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/exportStyle.js